import React, {Component} from 'react';
import ItemImage from '../utils/ItemImage';
import ChampionImage from '../utils/ChampionImage';

class MemberItems extends Component{
    render() {
        if(this.props.items != null ){ 
            return(
                <div className='flex flex-col justify-items-start text-left'>
                    {this.props.items.slice(0, 10).map((item,index) => (
                        <div key={index} className={index % 2 ? 'bg-slate-200 flex flex-row justify-between p-1' : 'flex flex-row justify-between p-1'}>
                            <div className='flex'>
                                <div className='pl-2 pr-2 leading-8'>
                                    <ItemImage name={item.item} size='32px' />
                                </div>
                                <div className='flex flex-nowrap mr-2' style={{minWidth: '22px'}}>
                                    <div className='align-middle' style={{lineHeight: '47px'}}>x {item.total}</div>
                                </div>    
                            </div>
                            <div className='flex'>
                                <div className='flex-wrap flex justify-end'>
                                    {item.unit.sort(function(a, b){
                                        if(a < b) { return -1; }
                                        if(a > b) { return 1; }
                                        return 0;
                                    }).map((unit,index) => (
                                    <ChampionImage key={index} name={unit} size={'large'}/>        
                                    ))}
                                </div>
                            </div>
                            
                        </div>
                    ))}  
                </div>
            )
        } else {
			return (
				<div className="flex justify-center justify-items-stretch">
					<div className="w-16 h-16 border-b-2 border-white-900 rounded-full animate-spin"></div>
				</div>
			)
		}
        
    }
}
export default MemberItems